import React from 'react';
import './ServiceCard.css';

const ServiceCard = props => {
    return (
        <div className="service-card" onClick={()=>props.changeService(props.serviceKey)}>
            <div className="service-card-icon">
                <i className={props.icon}/>
            </div>
            <span className="service-card-label">
                {props.label}
            </span>
        </div>
    );
};

export default ServiceCard;


// WEBPACK FOOTER //
// ./src/Components/LandingPage/Services/ServiceCard/ServiceCard.js